
<template>
  <div>
    <div>
      <!-- {{info}} -->
      <v-row>
        <template v-if="info.order_id">
          <v-col cols='4'>
            <v-text-field :value="info.order_id" label="Pedido" readonly></v-text-field>
          </v-col>
          <v-col cols='4'>
            <v-text-field :value="info.order_brand" label="Marca" readonly></v-text-field>
          </v-col>
          <v-col cols='4'>
            <v-text-field :value="info.order_total_order_bags" label="Quantidade" readonly></v-text-field>
          </v-col>

          <v-col cols='4'>
            <v-text-field :value="$moment(info.order_estimated_loading.substring(0,10)+'T12:00:00').format('l')" label="Dia de carregamento" readonly></v-text-field>
          </v-col>
        </template>
        <v-col cols='4'>
          <v-text-field :value="status_map[info.status_name]" label="Status" readonly></v-text-field>
        </v-col>

        <v-col cols='4'>
          <v-text-field :value="info.due_date" label="Vencimento" readonly></v-text-field>
        </v-col>

        <v-col cols='4'>
          <v-text-field :value="Number(info.ammount).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})" label="Valor" readonly></v-text-field>
        </v-col>
        <v-col cols='4'>
          <v-text-field :value="Number(info.ammount_payed).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})" label="Valor Pago" readonly></v-text-field>
        </v-col>
        <v-col cols='4'>
          <v-text-field :value="Number(info.rest_to_pay).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})" label="Valor Restante" readonly></v-text-field>
        </v-col>
        <v-col cols='11'>
          <v-textarea hide-details rows='2' readonly label="Comentários" :value="info.comment"></v-textarea>
        </v-col>
      </v-row>
      <!-- marca, quantidade, dia carregamento -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'InfoVrtTrans',
  props: {
    info: {
      type: Object,
    },
  },
  data() {
    return {
      status_map: {
        Overdue: 'Atrasado',
        Open: 'Aberto',
        Payed: 'Pago'
      }
    }
  },
  methods: {
    names() {
      
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>